export default __webpack_public_path__ + "static/media/ic_quick_answer_w.e443d5ef.svg";